export const classes = {
  label:
    'text-xs text-white font-medium py-0.5 px-3 rounded-lg inline-flex items-center font-semibold tracking-wide',
};
